'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-divider {\n  border-bottom: #f6f7f8 2px solid;\n  margin: .5em 0 1em 0; }\n";
styleInject_es(css_248z);
